import { makeStyles } from '@material-ui/core';
import React, { ReactElement } from 'react';
import TextSVG from 'assets/images/text.svg';

const useStyles = makeStyles(() => ({
  logo: {
    width: '24px',
    height: '24px',
    objectFit: 'cover',
  },
}));

function Text(): ReactElement {
  const classes: any = useStyles();
  return <img src={TextSVG} alt="Text icon" className={classes.logo} />;
}

export default Text;
